import React from 'react';
import PropTypes from 'prop-types';

import _ from 'lodash';
import { connect } from 'react-redux';
import Dialog from 'material-ui/Dialog';
import FlatButton from 'material-ui/FlatButton';
import { Tabs, Tab } from 'material-ui/Tabs';
import Dropzone from 'react-dropzone';

import Checkbox from 'material-ui/Checkbox';
import { closeCompanyForm, saveCompany } from '../../store/modules/company';
import PeoplePicker from '../../components/PeoplePicker/PeoplePicker';
import mergeStates from '../../helpers/mergeStates';
import FormAddress from '../FormAddress/FormAddress';
import FormContactDetail from '../FormContactDetail/FormContactDetail';
import FormBankEmbed from '../FormBankEmbed/FormBankEmbed';
import FormPlaceEmbed from '../FormPlaceEmbed/FormPlaceEmbed';
import { uploadFile, simplImageUrl } from '../../api/simplApi';

import SimplWysiwyg from '../SimplWysiwyg/SimplWysiwyg';
import FormTasks from '../FormTasks/FormTasks';
import SimplDatepicker from '../SimplDatepicker/SimplDatepicker';
import FormFileUpload from '../FormFileUpload/FormFileUpload';
import { RaisedButton } from 'material-ui';

const mapActionCreators = {
  saveCompany,
  closeCompanyForm,
};

const mapStateToProps = state => ({
  company: state.company.companies[state.company.formTarget],
  fetching: state.company.fetching,
  open: state.company.formOpen,
  formTarget: state.company.formTarget,
  user: state.login.user,
  files: _.filter(
    _.pick(
      state.file.files,
      state.company.companies[state.company.formTarget]
        ? state.company.companies[state.company.formTarget].files
        : {},
    ),
    ['deleted_at', null],
  ),
  tasks: _.pick(
    state.task.tasks,
    state.company.companies[state.company.current]
      ? state.company.companies[state.company.current].tasks
      : null,
  ),
});

const initialState = {
  id: null,
  logo: '',
  is_my_company: false,
  contactDetails: [],
  contact_details: null,
  banks: [],
  place: [],
  slideIndex: 0,
  meta: {
    foundation_date: '',
  },
  type: [],
  files: [],
  tasks: [],
  address: {},
  name: '',
  creator_id: '',
  short_name: '',
  created_at: '',
  updated_at: '',
  persons: [],
  person_ids: [],
};

class FormCompany extends React.Component {
  constructor(props) {
    super(props);
    this.state = initialState;
    this.receivedProps = false;
  }

  componentWillReceiveProps(nextProps) {
    if (this.props.open === false && nextProps.open === true) {
      setTimeout(() => this.focus(), 150);
    }

    if (
      typeof nextProps.formTarget !== 'undefined' &&
      nextProps.formTarget !== null &&
      this.receivedProps === false
    ) {
      if (
        typeof nextProps.company !== 'undefined' &&
        nextProps.company !== null
      ) {
        this.setState(nextProps.company);

        this.setState({
          files: Object.keys(nextProps.files).map(key => nextProps.files[key]),
          tasks: Object.keys(nextProps.tasks).map(key => nextProps.tasks[key]),
        });

        const meta = {};

        _.forOwn(nextProps.company.meta, (value, key) => {
          meta[key] = value.value;
        });

        this.setState({ meta });

        if (this.state.person_ids.length === 0) {
          this.setState({ person_ids: nextProps.company.persons });
        }

        if (typeof nextProps.company.contact_details !== 'undefined') {
          this.setState({ contactDetails: nextProps.company.contact_details });
        }

        if (typeof nextProps.company.banks !== 'undefined') {
          this.setState({ banks: nextProps.company.banks });
        }

        if (typeof nextProps.company.company_addresses !== 'undefined') {
          this.setState({ place: nextProps.company.company_addresses });
        }

        this.setState({ address: nextProps.company.addresses[0] });

        if (typeof nextProps.company.meta.notes !== 'undefined') {
          this.setState({
            notes: nextProps.company.meta.notes.value,
          });
        }

        this.receivedProps = true;
      }
    }
  }

  shouldComponentUpdate(nextProps, nextState) {
    if (JSON.stringify(nextState) !== JSON.stringify(this.state)) {
      return true;
    }

    if (this.state.contactDetails.length !== nextState.contactDetails.length) {
      return true;
    }

    if (this.state.place.length !== nextState.place.length) {
      return true;
    }

    if (this.state.banks.length !== nextState.banks.length) {
      return true;
    }

    if (
      JSON.stringify(_.omit(nextProps, ['saveCompany', 'closeCompanyForm'])) !==
      JSON.stringify(_.omit(this.props, ['saveCompany', 'closeCompanyForm']))
    ) {
      return true;
    }

    return false;
  }

  focus = () => {
    if (this.primaryInput && this.primaryInput !== null) {
      this.primaryInput.focus();
    }
  };

  onTextChange = content => {
    // console.log(content);

    const nextState = mergeStates(null, this.state, ['meta', 'notes'], content);

    this.setState(nextState);
  };

  resetState = () => {
    this.setState(initialState);
    this.receivedProps = false;
  };

  save = () => {
    // console.log('saving!', this.state);
    this.props.saveCompany(this.state);
    this.resetState();
    this.props.closeCompanyForm();
  };

  handleTabChange = value => {
    this.setState({
      slideIndex: value,
    });
  };

  handleChange = e => {
    // value and rawValue are different for some reason, let's ignore it for now.

    if (typeof e.target.rawValue !== 'undefined') {
      const picked = e.target.rawValue.map(value => value.value);
      this.setState({
        person_ids: picked,
        persons: picked,
      });
    } else {
      const nextState = mergeStates(e, this.state);
      this.setState(nextState);
    }
  };

  handleDate = date => {
    const nextState = mergeStates(
      null,
      this.state,
      'meta.foundation_date',
      date,
    );
    this.setState(nextState);
  };

  onDropLogo = files => {
    // console.log('Received files: ', files);
    uploadFile(files, data => {
      const logo = data[0].id;
      this.setState({ logo });
    });
  };

  onDrop = filesToUpload => {
    // console.log('Received filesToUpload: ', filesToUpload);
    uploadFile(filesToUpload, data => {
      const files = this.state.files;

      data.forEach(file => {
        // console.log(file);
        files.push(file);
      });

      this.setState({ files });
    });
  };

  addContactDetail = e => {
    const nextState = _.cloneDeep(this.state);

    if (e.button !== 0) {
      // abort on not left click
      return;
    }

    // note for later: converting collection to array is done by
    // nextState.contact_details = _.values(nextState.contact_details);

    nextState.contactDetails.push({
      id: `new_${Date.now()}`,
      value: '',
      type: 'email',
      note: '',
    });

    this.setState(nextState);
  };

  applyContactDetailChange = contactDetail => {
    const nextState = _.cloneDeep(this.state);

    for (let i = nextState.contactDetails.length - 1; i >= 0; i--) {
      if (contactDetail.id === nextState.contactDetails[i].id) {
        nextState.contactDetails[i] = contactDetail;
      }
    }

    this.setState(nextState);
  };

  handleContactDetailDeletion = contactDetail => {
    const nextState = _.cloneDeep(this.state.contactDetails);

    for (let i = nextState.length - 1; i >= 0; i--) {
      if (contactDetail.id === nextState[i].id) {
        nextState.splice(i, 1);
      }
    }

    this.setState({ contactDetails: nextState });
  };

  addPlace = () => {
    const nextState = _.cloneDeep(this.state);

    nextState.place.push({
      id: `new_${Date.now()}`,
      title: '',
      address: {
        street: '',
        extra_address_line: '',
        zip: '',
        city: '',
        province: '',
        country: 'DE',
      },
      contact_details: [],
      type: '',
      register_entry: '',
      foundation: '',
      ceo_id: null,
      notes: '',
      delete_this_place: false,
    });

    this.setState(nextState);
  };

  applyPlaceChange = companyAddress => {
    const nextState = _.cloneDeep(this.state);

    for (let i = nextState.place.length - 1; i >= 0; i--) {
      if (companyAddress.id === nextState.place[i].id) {
        nextState.place[i] = companyAddress;
      }
    }

    this.setState(nextState);
  };

  addBank = () => {
    const nextState = _.cloneDeep(this.state);
    // const sortedBanks = sortArray(nextState.banks, 'created_by', true);

    nextState.banks.push({
      id: `new_${Date.now()}`,
      name: '',
      owner: '',
      iban: '',
      bic: '',
      account_nr_active: false,
      account_nr: '',
      bank_identifier: '',
      sepa: '',
      sepa_notes: '',
      delete_this_bank: false,
    });
    // nextState.banks = sortedBanks;

    this.setState(nextState);
  };

  applyBankChange = bank => {
    const banks = _.cloneDeep(this.state.banks);

    for (let i = banks.length - 1; i >= 0; i--) {
      if (bank.id === banks[i].id) {
        banks[i] = bank;
      }
    }

    this.setState({ banks });
  };

  changeCompanyType = changedType => {
    let type = _.cloneDeep(this.state.type);

    if (type === null || !Array.isArray(type) || typeof type === 'undefined') {
      type = initialState.type;
    }

    if (type.indexOf(changedType) === -1) {
      type.push(changedType);
    } else {
      _.remove(type, n => n === changedType);
    }

    this.setState({
      type,
    });
  };

  renderCompanyTypes = () => {
    const companyTypeInputs = [];

    if (this.state.is_my_company) {
      return null;
    }

    const type =
      this.state.type === null || this.state.type === false
        ? []
        : this.state.type;

    companyTypeInputs.push(
      <div className="row" key="companyform-type">
        <div className="col-xs-12 col-sm-4">
          <label className="simpl-label" htmlFor="type">
            Typ
          </label>
        </div>
        <div className="col-xs-12 col-sm-4">
          <Checkbox
            label="Kunde"
            checked={type.indexOf('customer') !== -1}
            onCheck={() => this.changeCompanyType('customer')}
          />
          <Checkbox
            label="Lieferant / Freelancer"
            checked={type.indexOf('supplier') !== -1}
            onCheck={() => this.changeCompanyType('supplier')}
          />
          <Checkbox
            label="Institution"
            checked={type.indexOf('institution') !== -1}
            onCheck={() => this.changeCompanyType('institution')}
          />
        </div>
      </div>,
    );

    if (type.indexOf('customer') !== -1) {
      companyTypeInputs.push(
        <div className="row" key="companyform-customer_no">
          <div className="col-xs-12 col-sm-4">
            <label className="simpl-label" htmlFor="meta.customer_no">
              Kundennummer (Debitor) intern
            </label>
          </div>
          <div className="col-xs-12 col-sm-4">
            <input
              name="meta.customer_no"
              value={this.state.meta.customer_no}
              onChange={e => this.handleChange(e)}
            />
          </div>
        </div>,
      );
      companyTypeInputs.push(
        <div className="row" key="companyform-customer_no_extern">
          <div className="col-xs-12 col-sm-4">
            <label className="simpl-label" htmlFor="meta.customer_no_extern">
              Kundennummer (Debitor) extern
            </label>
          </div>
          <div className="col-xs-12 col-sm-4">
            <input
              name="meta.customer_no_extern"
              value={this.state.meta.customer_no_extern}
              onChange={e => this.handleChange(e)}
            />
          </div>
        </div>,
      );
    }

    if (type.indexOf('supplier') !== -1) {
      companyTypeInputs.push(
        <div className="row" key="companyform-supplier_no">
          <div className="col-xs-12 col-sm-4">
            <label className="simpl-label" htmlFor="meta.supplier_no">
              Lieferantennummer (Kreditor) intern
            </label>
          </div>
          <div className="col-xs-12 col-sm-4">
            <input
              name="meta.supplier_no"
              value={this.state.meta.supplier_no}
              onChange={e => this.handleChange(e)}
            />
          </div>
        </div>,
      );
      companyTypeInputs.push(
        <div className="row" key="companyform-supplier_no_extern">
          <div className="col-xs-12 col-sm-4">
            <label className="simpl-label" htmlFor="meta.supplier_no_extern">
              Lieferantennummer (Kreditor) extern
            </label>
          </div>
          <div className="col-xs-12 col-sm-4">
            <input
              name="meta.supplier_no_extern"
              value={this.state.meta.supplier_no_extern}
              onChange={e => this.handleChange(e)}
            />
          </div>
        </div>,
      );
    }

    if (type.indexOf('institution') !== -1) {
      companyTypeInputs.push(
        <div className="row" key="companyform-institutor_no">
          <div className="col-xs-12 col-sm-4">
            <label className="simpl-label" htmlFor="meta.institutor_no">
              Institutionsnummer intern
            </label>
          </div>
          <div className="col-xs-12 col-sm-4">
            <input
              name="meta.institutor_no"
              value={this.state.meta.institutor_no}
              onChange={e => this.handleChange(e)}
            />
          </div>
        </div>,
      );
      companyTypeInputs.push(
        <div className="row" key="companyform-institutor_no_extern">
          <div className="col-xs-12 col-sm-4">
            <label className="simpl-label" htmlFor="meta.institutor_no_extern">
              Institutionsnummer extern
            </label>
          </div>
          <div className="col-xs-12 col-sm-4">
            <input
              name="meta.institutor_no_extern"
              value={this.state.meta.institutor_no_extern}
              onChange={e => this.handleChange(e)}
            />
          </div>
        </div>,
      );
    }

    return companyTypeInputs;
  };

  renderContactDetails = () => {
    // this.state.contact_details are the exact outcome from the server,
    // they will get transformed into an array using this.state.contactDetails

    const sortedDetails = _.sortBy(this.state.contactDetails, [
      'sortedByType',
      'created_at',
    ]);

    return sortedDetails.map(detail => (
      <FormContactDetail
        key={`contact_detail_form_${detail.id}`}
        contactDetail={detail}
        onChange={contactDetail => {
          this.applyContactDetailChange(contactDetail);
        }}
        onDelete={contactDetail => {
          this.handleContactDetailDeletion(contactDetail);
        }}
      />
    ));
  };

  renderPlaces = () => {
    const places = [];

    this.state.place.forEach(detail => {
      places.push(
        <FormPlaceEmbed
          key={`place_${detail.id}`}
          companyAddress={detail}
          onChange={companyAddress => {
            this.applyPlaceChange(companyAddress);
          }}
        />,
      );
    });

    return places;
  };

  renderBanks = () => {
    const banks = [];
    // const sortedBanks = sortArray(this.state.banks, 'created_by', true);

    this.state.banks.forEach(detail => {
      banks.push(
        <FormBankEmbed
          key={`bank_${detail.id}`}
          bank={detail}
          onChange={bank => {
            this.applyBankChange(bank);
          }}
        />,
      );
    });

    return banks;
  };

  renderLogo = () => {
    if (this.state.logo !== null && this.state.logo.length) {
      return (
        <div>
          <img
            src={`${simplImageUrl()}${this.props.user.current_simpl_account}/${
              this.state.logo
            }?w=200`}
            alt=""
          />
          <div>Hier klicken um ein neues Logo hinzuzufügen</div>
          <br />
        </div>
      );
    }
    return <div>Hier klicken um ein Logo hinzuzufügen</div>;
  };

  render() {
    const props = this.props;

    const opened = typeof props.open !== 'undefined' ? props.open : false;

    let buttonText = 'Erstellen';
    if (this.state.id !== null) {
      buttonText = 'Speichern';
    }

    const actions = [
      <FlatButton
        label="Abbrechen"
        primary={false}
        onMouseDown={() => {
          this.resetState();
          props.closeCompanyForm();
        }}
      />,
      <RaisedButton
        style={{ marginLeft: 10 }}
        label={buttonText}
        primary
        disabled={this.state.name.trim().length === 0}
        onMouseDown={() => this.save()}
      />,
    ];

    let title = 'Neues Unternehmen erstellen';
    if (this.state.id !== null) {
      title = `"${this.state.name}" bearbeiten`;
    } else if (this.state.name.length) {
      title = `"${this.state.name}" erstellen`;
    }

    return (
      <Dialog
        title={title}
        actions={actions}
        modal={false}
        open={opened}
        autoScrollBodyContent
        className="form modal-center"
        contentClassName="form-container form-container--company"
        titleClassName="form-header"
        actionsContainerClassName="form-footer"
        bodyClassName="form-body form-body-tabbed"
      >
        <Tabs
          onChange={this.handleTabChange}
          value={this.state.slideIndex}
          inkBarStyle={{ backgroundColor: '#4a90e2' }}
          tabItemContainerStyle={{
            backgroundColor: '#ffffff',
            height: 60,
            minHeight: 60,
            borderBottomWidth: 1,
            borderBottomColor: '#ccc',
            borderBottomStyle: 'solid',
          }}
        >
          <Tab
            label="Generell"
            value={0}
            style={{ color: '#4a90e2', fontWeight: 700, flex: 1 }}
          >
            <div className="PadMe">
              <div className="row">
                <div className="col-xs-12 col-sm-4">
                  <label className="simpl-label" htmlFor="name">
                    Unternehmensname
                  </label>
                </div>
                <div className="col-xs-12 col-sm-8">
                  <input
                    name="name"
                    required
                    value={this.state.name}
                    onChange={e => this.handleChange(e)}
                    ref={input => {
                      this.primaryInput = input;
                    }}
                  />
                </div>
              </div>
              <div className="row">
                <div className="col-xs-12 col-sm-4">
                  <label className="simpl-label" htmlFor="short_name">
                    Kurzbezeichnung
                  </label>
                </div>
                <div className="col-xs-12 col-sm-4">
                  <input
                    name="short_name"
                    value={this.state.short_name}
                    onChange={e => this.handleChange(e)}
                  />
                </div>
              </div>

              {this.renderCompanyTypes()}

              <hr />

              <div className="row">
                <div className="col-xs-12">
                  <h2>Anschrift</h2>
                </div>
              </div>
              <FormAddress
                value={this.state.address}
                onChange={address => {
                  this.setState({ address });
                }}
              />

              <hr />

              <div className="row">
                <div className="col-xs-12">
                  <h2>Kommunikation</h2>
                </div>
              </div>

              {this.renderContactDetails()}

              <div className="row">
                <div className="col-xs-12 text-center">
                  <button
                    className="button button--link"
                    onMouseDown={e => {
                      this.addContactDetail(e);
                    }}
                  >
                    + Kommunikationsart hinzufügen
                  </button>
                </div>
              </div>

              <hr />

              <div className="row">
                <div className="col-xs-12">
                  <h2>Kontakte</h2>
                </div>
              </div>
              <div className="row">
                <div className="col-xs-12 col-sm-4">
                  <label className="simpl-label" htmlFor="responsible">
                    Kontakte
                  </label>
                </div>
                <div className="col-xs-12 col-sm-8">
                  <PeoplePicker
                    type="persons"
                    name="person_ids"
                    value={this.state.person_ids}
                    multi
                    onChange={e => this.handleChange(e)}
                  />
                </div>
              </div>

              <hr />

              <div className="row">
                <div className="col-xs-12">
                  <h2>Zusätzliche Informationen</h2>
                </div>
              </div>

              <div className="row">
                <div className="col-xs-12 col-sm-4">
                  <label className="simpl-label" htmlFor="meta.legal_form">
                    Rechtsform
                  </label>
                </div>
                <div className="col-xs-12 col-sm-4">
                  <input
                    name="meta.legal_form"
                    value={this.state.meta.legal_form}
                    onChange={e => this.handleChange(e)}
                  />
                </div>
              </div>
              <div className="row">
                <div className="col-xs-12 col-sm-4">
                  <label className="simpl-label" htmlFor="meta.industry">
                    Branche
                  </label>
                </div>
                <div className="col-xs-12 col-sm-4">
                  <input
                    name="meta.industry"
                    value={this.state.meta.industry}
                    onChange={e => this.handleChange(e)}
                  />
                </div>
              </div>
              <div className="row">
                <div className="col-xs-12 col-sm-4">
                  <label
                    className="simpl-label"
                    htmlFor="meta.trade_register_entry"
                  >
                    Handelsregistereintrag
                  </label>
                </div>
                <div className="col-xs-12 col-sm-4">
                  <input
                    name="meta.trade_register_entry"
                    value={this.state.meta.trade_register_entry}
                    onChange={e => this.handleChange(e)}
                  />
                </div>
              </div>
              <div className="row">
                <div className="col-xs-12 col-sm-4">
                  <label className="simpl-label" htmlFor="meta.tax_number">
                    Steuernummer
                  </label>
                </div>
                <div className="col-xs-12 col-sm-4">
                  <input
                    name="meta.tax_number"
                    value={this.state.meta.tax_number}
                    onChange={e => this.handleChange(e)}
                  />
                </div>
              </div>
              <div className="row">
                <div className="col-xs-12 col-sm-4">
                  <label className="simpl-label" htmlFor="meta.vat_number">
                    Ust.-ID Nummer
                  </label>
                </div>
                <div className="col-xs-12 col-sm-4">
                  <input
                    name="meta.vat_number"
                    value={this.state.meta.vat_number}
                    onChange={e => this.handleChange(e)}
                  />
                </div>
              </div>
              <div className="row">
                <div className="col-xs-12 col-sm-4">
                  <label className="simpl-label" htmlFor="start-time">
                    Gründungsdatum
                  </label>
                </div>
                <div className="col-xs-12 col-sm-4">
                  <SimplDatepicker
                    defaultValue={this.state.meta.foundation_date}
                    dateFormat="DD.MM.YYYY"
                    dateFormatSubmit="DD. MM. YYYY"
                    onChange={date => {
                      this.handleDate(date);
                    }}
                  />
                </div>
              </div>
              <div className="row">
                <div className="col-xs-12 col-sm-4">
                  <label className="simpl-label" htmlFor="meta.notes">
                    Bemerkungen
                  </label>
                </div>
                <div className="col-xs-12 col-sm-8">
                  <SimplWysiwyg
                    content={this.state.meta.notes}
                    onUpdate={content => this.onTextChange(content)}
                  />
                </div>
              </div>
              <hr />

              <FormTasks
                tasks={this.state.tasks}
                onUpdate={tasks =>
                  this.setState({
                    tasks,
                  })
                }
              />

              <hr />

              <div className="row flex-vcenter">
                <div className="col-xs-6 flex-vcenter">
                  <h3>Logo</h3>
                </div>
                <div className="col-xs-6 text-right flex-vcenter">
                  {this.state.logo && this.state.logo.length ? (
                    <a
                      href="#removeLogo"
                      onClick={e => {
                        e.preventDefault();
                        this.setState({ logo: '' });
                      }}
                    >
                      Logo entfernen
                    </a>
                  ) : null}
                </div>
              </div>

              <Dropzone
                onDrop={this.onDropLogo}
                multiple={false}
                className="dropzone"
              >
                {this.renderLogo()}
              </Dropzone>

              <hr />

              <FormFileUpload
                files={this.state.files}
                onUpdate={files =>
                  this.setState({
                    files,
                  })
                }
              />
            </div>
          </Tab>
          <Tab
            label="Standorte"
            value={1}
            style={{
              color: '#4a90e2',
              fontWeight: 700,
              flex: 1,
            }}
          >
            <div className="PadMe">
              {this.renderPlaces()}

              <div className="row">
                <div className="col-xs-12 text-center">
                  <a
                    href="#addPlace"
                    onMouseDown={() => {
                      this.addPlace();
                    }}
                  >
                    + Weiteren Standort hinzufügen
                  </a>
                </div>
              </div>
            </div>
          </Tab>
          <Tab
            label="Bankdaten"
            value={2}
            style={{
              color: '#4a90e2',
              fontWeight: 700,
              flex: 1,
            }}
          >
            <div className="PadMe">
              {this.renderBanks()}

              <div className="row">
                <div className="col-xs-12 text-center">
                  <a
                    href="#addBank"
                    onMouseDown={() => {
                      this.addBank();
                    }}
                  >
                    + Weiteres Konto hinzufügen
                  </a>
                </div>
              </div>
            </div>
          </Tab>
        </Tabs>
      </Dialog>
    );
  }
}
FormCompany.propTypes = {
  saveCompany: PropTypes.func.isRequired,
  closeCompanyForm: PropTypes.func.isRequired,
  formTarget: PropTypes.oneOfType([
    // eslint-disable-line react/no-unused-prop-types
    PropTypes.string,
    PropTypes.number,
  ]),
  company: PropTypes.object, // eslint-disable-line react/no-unused-prop-types
  files: PropTypes.array, // eslint-disable-line react/no-unused-prop-types
  tasks: PropTypes.object, // eslint-disable-line react/no-unused-prop-types
  user: PropTypes.object.isRequired,
  open: PropTypes.bool,
};
export default connect(mapStateToProps, mapActionCreators)(FormCompany);



// WEBPACK FOOTER //
// ./src/components/FormCompany/FormCompany.js